import type {MaybeNil} from "app/utils/types";
import {isNil} from "app/utils/stdlib";
import {InvalidValue} from "app/employee/controlCard/display/InvalidValue";
import type {RefOption} from "app/employee/controlCard/refUtils";

type EmployeeRefOptions = RefOption & {__typename: "EmployeeColumnRefOptions"};
type EmployeeRefOptionValue = EmployeeRefOptions["options"][number];

export const DisplayEmployeeRefOptionValue = ({value}: {value: MaybeNil<EmployeeRefOptionValue>}) => {
  if (isNil(value)) {
    return <InvalidValue />;
  } else {
    const {name} = value.employee;
    return <>{name}</>;
  }
};
